import { useEffect, useRef, useState } from 'react';
export function useScrollHeight() {
    const ref = useRef(null);
    const [scrollHeight, setScrollHeight] = useState(0);
    useEffect(() => {
        const calculateScrollHeight = () => {
            if (ref.current) {
                setScrollHeight(ref.current.scrollHeight);
            }
        };
        calculateScrollHeight();
        window.addEventListener('resize', calculateScrollHeight);
        return () => window.removeEventListener('resize', calculateScrollHeight);
    }, []);
    return [ref, scrollHeight];
}
//# sourceMappingURL=useScrollHeight.js.map